export class SingleTimeoutManager {
  timeout = null;

  set(cb, time) {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.timeout = null;
      cb && cb();
    }, time);
  }

  setDelay(time) {
    return this.set(null, time);
  }

  clear() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  active() {
    return this.timeout;
  }
}
